


















import { defineComponent, onMounted, toRefs } from '@vue/composition-api';
import QuestionTooltip from '../../common/question-tooltip/index.vue';
import { trackEvent } from '@tt4b/ttam-utils';

enum TiktokEventType {
  webevent = 'webevent',
  appevent = 'appevent',
  offlineevent = 'offlineevent',
}

const name = 'ttam-tracking-data-empty';
export default defineComponent({
  name,
  components: {
    QuestionTooltip,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    textKey: {
      type: String,
      default: '',
    },
    tipsTextKey: {
      type: String,
      default: '',
    },
    linkKey: {
      type: String,
      default: '',
    },
    linkUrl: {
      type: String,
      default: '',
    },
    linkPlace: {
      type: String,
      default: '',
    },
    fixClass: {
      type: String,
      default: '',
    },
    reportTiktokEventType: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { reportTiktokEventType } = toRefs(props);

    onMounted(() => {
      if (reportTiktokEventType.value) {
        trackEvent('ttam_ad_tracking_module_no_event', {
          tiktok_event_type: reportTiktokEventType.value,
        });
      }
    });

    return { name };
  },
});
